import React from 'react';

// PM‑editable copy separated from UI
export const assetPortfolioTourCopy = {
  headerTitle: 'Asset Portfolio',
  headerBody: 'Manage your entire investment portfolio across multiple asset classes with real-time tracking and projections.',
  summaryTitle: 'Portfolio Summary',
  summaryBody: 'See your total portfolio value, asset allocation, and expected returns at a glance.',
  allocationTitle: 'Asset Allocation Chart',
  allocationBody: 'Visualize how your investments are distributed across Equity, Debt, Real Estate, Gold, and other assets.',
  tableTitle: 'Asset Details Table',
  tableBody: 'Track individual assets with current values, expected returns, liquidity status, and risk levels.',
  performanceTitle: 'Performance Tracker',
  performanceBody: 'Monitor portfolio performance over time and compare against your retirement goals.',
  eventsTitle: 'Special Inflow Events',
  eventsBody: 'Plan for one-time inflows like bonuses, inheritance, or asset sales that will boost your portfolio.',
};

const Tip = ({ title, body }) => (
  <div>
    <div style={{ fontWeight: 600, color: 'var(--foreground, #111827)' }}>{title}</div>
    <div style={{ marginTop: 6, fontSize: 14, color: 'var(--muted-foreground, #6B7280)' }}>{body}</div>
  </div>
);

export const getAssetPortfolioTourSteps = () => [
  {
    target: '[data-tour="asset-header"]',
    content: <Tip title={assetPortfolioTourCopy.headerTitle} body={assetPortfolioTourCopy.headerBody} />,
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="asset-summary"]',
    content: <Tip title={assetPortfolioTourCopy.summaryTitle} body={assetPortfolioTourCopy.summaryBody} />,
    placement: 'bottom',
  },
  {
    target: '[data-tour="asset-table"]',
    content: <Tip title={assetPortfolioTourCopy.tableTitle} body={assetPortfolioTourCopy.tableBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="asset-events"]',
    content: <Tip title={assetPortfolioTourCopy.eventsTitle} body={assetPortfolioTourCopy.eventsBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="asset-performance"]',
    content: <Tip title={assetPortfolioTourCopy.performanceTitle} body={assetPortfolioTourCopy.performanceBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="asset-allocation"]',
    content: <Tip title={assetPortfolioTourCopy.allocationTitle} body={assetPortfolioTourCopy.allocationBody} />,
    placement: 'top',
  },
];
